import { CountryCode } from 'libphonenumber-js';

export const postcodeSampleMap: Partial<Record<CountryCode, string>> = {
    GB: "SW1A 1AA",
    IT: "00186",
};

const postcodeRegexMap: Partial<Record<CountryCode, RegExp>> = {
    GB: /^((GIR 0AA)|((([A-Z][0-9]{1,2})|(([A-Z][A-HK-Y][0-9]{1,2})|(([A-Z][0-9][A-Z])|([A-Z][A-HK-Y][0-9]?[A-Z]))))\s?[0-9][A-Z]{2}))$/,
    IT: /^\d{5}$/,
};

export function validatePostcode(countryCode: CountryCode, postcode: string): boolean {
    const regex = postcodeRegexMap[countryCode];
    if (!regex) {
        return true;
    }
    return regex.test(postcode.trim().toUpperCase());
}